import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useMessages } from '../../hooks/UseMessages';
import {useNavigate} from "react-router-dom";

export function BroadcastPanel({ user }) {
    const { sendBroadcast, loading } = useMessages();
    const [status, setStatus] = useState(null);
    const [targetUsername, setTargetUsername] = useState('KPDesign'); // Дефолтний юзер
    const [message, setMessage] = useState({
        text: '',
        imageUrl: '',
        videoUrl: '',
        type: 1
    });

    const navigate = useNavigate();
    const onBackClicked = () => navigate('/');

    const modules = {
        toolbar: [['bold', 'italic', 'underline'], ['blockquote', 'code'], ['link'], ['clean']],
    };

    const getCleanText = () => {
        if (!message.text) return "";

        let text = message.text;

        text = text.replace(/&nbsp;/g, " ");
        text = text.replace(/<\/p><p>/g, "\n");
        text = text.replace(/<p><br><\/p>/g, "\n"); // Порожні рядки Quill

        text = text.replace(/<(\/?)strong\b[^>]*>/gi, "<$1b>");
        text = text.replace(/<(\/?)b\b[^>]*>/gi, "<$1b>");

        text = text.replace(/<(\/?)em\b[^>]*>/gi, "<$1i>");
        text = text.replace(/<(\/?)i\b[^>]*>/gi, "<$1i>");

        text = text.replace(/<(?!(\/?(b|i|a|code|u)))\b[^>]*>/gi, "");

        return text.trim();
    };

    const handleSend = async (isTest = false) => {
        setStatus(null);
        const cleanText = getCleanText();

        const payload = {
            text: cleanText,
            imageUrl: message.imageUrl,
            videoUrl: message.videoUrl,
            type: message.type,
            targetUsername: isTest ? targetUsername : null // Передаємо нік для тесту
        };

        try {
            await sendBroadcast(user.token, payload);
            setStatus({
                type: 'success',
                text: isTest ? `✅ Тест надіслано @${targetUsername}` : '🚀 Розсилку всім запущено!'
            });
            if (!isTest) setMessage({ text: '', imageUrl: '', videoUrl: '', type: 1 });
        } catch (err) {
            setStatus({ type: 'error', text: '❌ Помилка: ' + err.message });
        }
    };

    return (
        <div style={{padding: '40px', maxWidth: '800px', margin: '0 auto', fontFamily: 'sans-serif'}}>
            <button
                onClick={onBackClicked}
                style={{
                    padding: '8px 16px',
                    borderRadius: '8px',
                    border: '1px solid #d1d5db',
                    backgroundColor: '#fff',
                    cursor: 'pointer',
                    fontWeight: '600'
                }}
            >
                ← Назад
            </button>
            <h2 style={{marginBottom: '25px', color: '#111827'}}>📢 Керування розсилкою</h2>

            <div style={{display: 'flex', flexDirection: 'column', gap: '25px'}}>

                <div style={{backgroundColor: 'white'}}>
                    <label style={{fontWeight: '600', display: 'block', marginBottom: '8px'}}>Текст повідомлення</label>
                    <ReactQuill
                        theme="snow"
                        value={message.text}
                        onChange={(content) => setMessage({...message, text: content})}
                        modules={modules}
                        style={{height: '200px', marginBottom: '50px'}}
                    />
                </div>

                {/* Лінки — одне під одним */}
                <div style={{display: 'flex', flexDirection: 'column', gap: '15px'}}>
                    <div>
                        <label style={{fontWeight: '600', display: 'block', marginBottom: '8px'}}>Image URL</label>
                        <input
                            type="text"
                            value={message.imageUrl}
                            onChange={(e) => setMessage({...message, imageUrl: e.target.value})}
                            style={{width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #d1d5db'}}
                        />
                    </div>
                    <div>
                        <label style={{fontWeight: '600', display: 'block', marginBottom: '8px'}}>Video URL</label>
                        <input
                            type="text"
                            value={message.videoUrl}
                            onChange={(e) => setMessage({...message, videoUrl: e.target.value})}
                            style={{width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #d1d5db'}}
                        />
                    </div>
                </div>

                <hr style={{border: '0', borderTop: '1px solid #eee', margin: '10px 0'}}/>

                <div style={{
                    backgroundColor: '#f3f4f6',
                    padding: '20px',
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'flex-end',
                    gap: '15px'
                }}>
                    <div style={{flex: 1}}>
                        <label style={{fontWeight: '600', display: 'block', marginBottom: '8px', fontSize: '14px'}}>
                            Тестовий Username (без @)
                        </label>
                        <input
                            type="text"
                            value={targetUsername}
                            onChange={(e) => setTargetUsername(e.target.value)}
                            style={{width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #d1d5db'}}
                        />
                    </div>
                    <button
                        onClick={() => handleSend(true)}
                        disabled={loading || !message.text}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: '#10b981',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            height: '37px'
                        }}
                    >
                        Надіслати тест @{targetUsername}
                    </button>
                </div>

                {/* Основна кнопка */}
                <button
                    onClick={() => handleSend(false)}
                    disabled={loading || !message.text}
                    style={{
                        padding: '18px',
                        backgroundColor: '#4f46e5',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        fontWeight: '700',
                        cursor: 'pointer',
                        fontSize: '16px'
                    }}
                >
                    {loading ? 'Надсилаємо...' : 'ЗАПУСТИТИ РОЗСИЛКУ НА ВСІХ'}
                </button>

                {status && (
                    <div style={{
                        padding: '15px',
                        borderRadius: '8px',
                        backgroundColor: status.type === 'success' ? '#dcfce7' : '#fee2e2',
                        color: status.type === 'success' ? '#166534' : '#991b1b',
                        textAlign: 'center'
                    }}>
                        {status.text}
                    </div>
                )}
            </div>
        </div>
    );
}